import { Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appHistoryClass]'
})
export class HistoryClassDirective implements OnChanges {
    @Input() historySectionData: { totalDaysTaken: number; globalSla: number; isCard: boolean } | null = null;

    constructor(private _el: ElementRef, private _renderer: Renderer2) {}

    ngOnChanges(): void {
        if (this.historySectionData) {
            if (!this.historySectionData.isCard) {
                this.updateClass();
            } else this.updateCardClass();
        }
    }

    private updateClass(): void {
        const element = this._el.nativeElement;
        const classes = ['bg-red', 'bg-green', 'bg-orange'];

        // Remove all  classes
        classes.forEach(className => {
            this._renderer.removeClass(element, className);
        });
        if (this.historySectionData) {
            console.log(this.historySectionData);
            if (+this.historySectionData.totalDaysTaken >= +this.historySectionData.globalSla) {
                this._renderer.addClass(element, 'bg-red');
            } else if (+this.historySectionData.totalDaysTaken === +this.historySectionData.globalSla - 1) {
                this._renderer.addClass(element, 'bg-orange');
            } else {
                this._renderer.addClass(element, 'bg-green');
            }
        }
    }
    private updateCardClass(): void {
        const element = this._el.nativeElement;
        const classes = ['card-red', 'card-orange', 'card-green'];

        // Remove all  classes
        classes.forEach(className => {
            this._renderer.removeClass(element, className);
        });

        if (this.historySectionData) {
            if (+this.historySectionData.totalDaysTaken >= +this.historySectionData.globalSla) {
                this._renderer.addClass(element, 'card-red');
            } else if (+this.historySectionData.totalDaysTaken === +this.historySectionData.globalSla - 1) {
                this._renderer.addClass(element, 'card-orange');
            } else {
                this._renderer.addClass(element, 'card-green');
            }
        }
    }
}
